import React, { useContext, useLayoutEffect, useState } from 'react';
import Box from '../Box';
import { spacingValue } from '../system';
import StackView from '../StackView';
import StepperProgressContext from './Context';
var CIRCLE_SIZE = 1.5;
var BASE_COLOR = 'separatorSecondary';

function Line() {
  var _useContext = useContext(StepperProgressContext),
      active = _useContext.active,
      activeColor = _useContext.activeColor;

  return /*#__PURE__*/React.createElement(Box, {
    position: "absolute",
    width: "100%",
    height: "3px",
    x: "calc(-100% + " + spacingValue(CIRCLE_SIZE / 2) + ")",
    y: "4.5px",
    backgroundColor: BASE_COLOR,
    zIndex: 0
  }, /*#__PURE__*/React.createElement(Box, {
    width: "100%",
    height: "100%",
    backgroundColor: activeColor,
    transformOrigin: "left center",
    transition: "transform 280ms ease-out",
    style: {
      transform: "scaleX(" + (active ? 1 : 0)
    }
  }));
}

var _ref = /*#__PURE__*/React.createElement(Line, null);

function Indicator(props) {
  var context = useContext(StepperProgressContext);
  var active = props.active === undefined ? context.active : props.active;
  var activeColor = props.activeColor === undefined ? context.activeColor : props.activeColor;

  var _useState = useState('0ms'),
      delay = _useState[0],
      setDelay = _useState[1];

  useLayoutEffect(function () {
    setDelay(active === true ? '0ms' : '280ms');
  }, [active]);
  return /*#__PURE__*/React.createElement(Box, null, context.includeLine && _ref, /*#__PURE__*/React.createElement(Box, {
    width: CIRCLE_SIZE,
    height: CIRCLE_SIZE,
    radius: "circle",
    backgroundColor: active ? activeColor : BASE_COLOR,
    position: "relative",
    zIndex: 1,
    transition: "background-color 280ms ease-out",
    transitionDelay: delay
  }));
}

function Step(_ref2) {
  var active = _ref2.active,
      activeColor = _ref2.activeColor,
      renderStart = _ref2.renderStart,
      renderEnd = _ref2.renderEnd;
  return /*#__PURE__*/React.createElement(StackView, {
    alignment: "center",
    position: "relative"
  }, renderStart, /*#__PURE__*/React.createElement(Indicator, {
    active: active,
    activeColor: activeColor
  }), renderEnd);
}

export default Step;